import { c as _c } from "react/compiler-runtime";
import { ProductCardSkeleton } from '@/components/ProductCard/ProductCardSkeleton';
import Slider from '@/components/Slider/Slider';
const SKELETON_ITEM_COUNT = 8;
export const ProductSliderSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="gap-2"><Slider className={{
        root: "[--slides-to-show:2.15] sm:[--slides-to-show:3.15] md:[--slides-to-show:4.18] lg:[--slides-to-show:4.2] xl:[--slides-to-show:4.15]"
      }}>{Array.from({
          length: SKELETON_ITEM_COUNT
        }).map(_temp)}</Slider></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(_, index) {
  return <ProductCardSkeleton key={index} />;
}